<div style="height: 6px; z-index:10000;">
    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" *ngIf="loadingNumber() > 0"></p-progressBar>
</div>

<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <div
        class="align-items-center flex justify-content-center lg:px-8 md:px-6 px-4 py-8 surface-ground ng-star-inserted">
        <div class="surface-card p-4 shadow-2 border-round w-full lg:w-6">
            <div class="text-center mb-5">
                <img src="assets/images/redur-logo.svg" style="height:65px" class="mb-2 mt-2">

                <p-divider />

                <div class="text-900 text-2xl font-medium mb-3 mt-4">Bitte anmelden</div>
            </div>

            <p-divider />

            <div>
                <div class="field">
                    <label for="email1" class="block text-900 font-medium mb-2">Email</label>
                    <input id="email1" type="text" placeholder="Email-Adresse" pInputText class="w-full mb-3"
                        formControlName="username" required>
                </div>
                <div class="field">
                    <label for="password1" class="block text-900 font-medium mb-2">Passwort</label>
                    <input id="password1" type="password" placeholder="Passwort" pInputText class="w-full mb-3"
                        formControlName="password" required>
                </div>
                @if(errorMessage) {
                <div class="mb-4 text-center">
                    <div class="p-error font-bold">{{ errorMessage }}<br></div>
                </div>
                }

                <!-- <div class="flex align-items-center justify-content-between mb-6">
            <div class="flex align-items-center">
                <p-checkbox id="rememberme" [binary]="true" styleClass="mr-2"></p-checkbox>
                <label for="rememberme1">Remember me</label>
            </div>
            <a class="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer">Forgot password?</a>
        </div> -->

                <button pButton pRipple label="Anmelden" icon="pi pi-user" class="w-full"></button>
            </div>
        </div>
    </div>
</form>